export function getShortCodeHelpers(pathname: string, queryParams: Record<string, string>) {
  function getShortCode(): string | null {
    const match = pathname?.match(/^\/r\/(.+)/);

    return match ? match[1] : null;
  }

  function getMergeTagFallback(): { practiceId: string; patientId: string } | null {
    const match = pathname?.match(/^\/p\/([^\/]+)\/([^\/]+)$/);
    const practiceId = match ? match[1] : queryParams?.practice_id;
    const patientId = match ? match[2] : queryParams?.patient_id;

    if (!practiceId || !patientId) {
      return null;
    }

    const queryParamsKeys = Object.keys(queryParams);

    // Handle unsubscribe links which have other query string parameters
    if (queryParamsKeys.length > 0 && queryParamsKeys.length !== 2) {
      return null;
    }

    return { practiceId, patientId };
  }

  return {
    get isShortCode() {
      return !!getShortCode();
    },
    get isMergeTagFallback() {
      return !!getMergeTagFallback();
    },
    get shortCode() {
      return getShortCode();
    },
    get mergeTagFallback() {
      return getMergeTagFallback();
    },
  };
}
